import { TaxRegimeEnum } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';
import { PurchaseTaxRegime } from '@/core/domain/purchase/Purchase.types';
import { Select, SelectProps } from 'antd';

interface Props extends SelectProps {
  isPurchase?: boolean;
}

export const taxRegimeOptions = [
  { value: TaxRegimeEnum.normal, label: 'Regime Normal' },
  { value: TaxRegimeEnum.simple, label: 'Simples Nacional' },
  {
    value: TaxRegimeEnum.simplesNationalMei,
    label: 'Simples Nacional - Microempreendedor Individual - MEI',
  },
  {
    value: TaxRegimeEnum.simpleNationalExcessSublimitGrossRevenue,
    label: 'Simples nacional com excesso do sublimite',
  },
];

export const taxRegimePurchaseOptions = [
  { value: PurchaseTaxRegime.normalRegime, label: 'Regime Normal' },
  { value: PurchaseTaxRegime.simpleNational, label: 'Simples Nacional' },
  {
    value: PurchaseTaxRegime.simplesNationalMei,
    label: 'Simples Nacional - Microempreendedor Individual - MEI',
  },
  {
    value: PurchaseTaxRegime.simpleNationalExcess,
    label: 'Simples nacional com excesso do sublimite',
  },
];

const TaxRegimeSelect = ({ isPurchase = false, ...props }: Props) => {
  return (
    <Select
      {...props}
      options={isPurchase ? taxRegimePurchaseOptions : taxRegimeOptions}
    />
  );
};

export default TaxRegimeSelect;
